import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";
import toast from "react-hot-toast";

export function useDriverScorecards(enabled) {
  const [scorecards, setScorecards] = useState([]);
  const [loading,    setLoading]    = useState(true);

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const { data } = await api.get("/api/drivers/scorecards");
      setScorecards(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load driver scorecards");
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => { load(); }, [load]);

  return { scorecards, loading, reload: load };
}
